import {
  AnchorButton as BlueprintAnchorButton,
  AnchorButtonProps as BlueprintAnchorButtonProps,
  PopoverPosition as BlueprintPopoverPosition,
} from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { IconWrapperProps } from 'bones/design-system/components/icons/Icon';
import { Tooltip } from 'bones/design-system/components/Tooltip';

export const ICON_SIZE_BY_AVATAR_SIZE: Record<
  InteractiveAvatarProps['size'],
  IconWrapperProps['size']
> = {
  lg: 'xl',
  md: 'lg',
  sm: 'sm',
  xs: 'xs',
};

export type InteractiveAvatarProps = Pick<
  BlueprintAnchorButtonProps,
  'active' | 'disabled' | 'onClick'
> & {
  'data-testid'?: never;
  className?: string;
  image?: React.ReactNode;
  size: 'lg' | 'md' | 'sm' | 'xs';
  testId?: string;
  text?: string;
  tooltip?: string;
  tooltipPosition?: BlueprintPopoverPosition;
};

export const InteractiveAvatar: React.VFC<InteractiveAvatarProps> = ({
  active,
  className,
  disabled,
  image,
  onClick,
  size,
  testId,
  text,
  tooltip,
  tooltipPosition = BlueprintPopoverPosition.BOTTOM,
}) => (
  <Tooltip
    description={tooltip || ''}
    disabled={!tooltip}
    position={tooltipPosition}
  >
    <BlueprintAnchorButton
      active={active}
      className={classNames(className, 'vb-avatar', `vb-avatar-size--${size}`, {
        'vb-avatar--initials': !image,
      })}
      data-testid={testId}
      disabled={disabled}
      onClick={onClick}
    >
      {image || text}
    </BlueprintAnchorButton>
  </Tooltip>
);
